import type * as store from '@attain-apps/fe/web/main/lib/store'

import type { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {} as const satisfies store.actions.Config.Constraint<State>
}
